import React, { createContext, useState, useContext, ReactNode } from 'react';
import {
    checkCredentials,
    getAreLocalStorageUserData,
    webToken,
    lsToken as tokenFromLocalStorage,
} from '../utils/authHelpers';
import api, { assistantApi, cachedApi, setAxiosToken } from '../services/api';

interface AuthContextType {
    token: string | null;
    handleSaveToken: (newToken: string) => void;
    isAuthenticated: boolean | null;
    handleIsAuthenticated: (value: boolean) => void;
    checkAuthentication: () => Promise<boolean>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const [token, setToken] = useState<string | null>(tokenFromLocalStorage);
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(
        null
    );

    const checkAuthentication = async () => {
        if (getAreLocalStorageUserData()) {
            setAxiosToken(api, token);
            setAxiosToken(cachedApi, token);
            setAxiosToken(assistantApi, webToken);
            const isValidToken = await checkCredentials();
            setIsAuthenticated(isValidToken);
            return isValidToken;
        } else {
            setIsAuthenticated(false);
            return false;
        }
    };

    const handleSaveToken = (newToken: string) => {
        setToken(newToken);
    };

    const handleIsAuthenticated = (value: boolean) => {
        setIsAuthenticated(value);
    };

    const data = {
        token,
        isAuthenticated,
    };

    const methods = {
        handleSaveToken,
        checkAuthentication,
        handleIsAuthenticated,
    };
    return (
        <AuthContext.Provider
            value={{
                ...data,
                ...methods,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be used within AuthProvider');
    return ctx;
};
